import CryptoJS from 'crypto-js';

class UserRepository {
    constructor() {
        // Base URL for your API - change this to your deployed server URL
        //this.apiUrl = 'http://147.93.95.186:5000/api'; // Default for local development
        this.apiUrl = 'https://server.unitesainteveronique.com/api'; // Default for local development
    }

    // Set the API URL (useful for different environments)
    setApiUrl(url) {
        this.apiUrl = url;
    }

    async login(pseudo, password) {
        // Compute the double SHA-256 hash of the provided password
        const hash = CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex);
        const doubleHash = CryptoJS.SHA256(hash).toString(CryptoJS.enc.Hex);

        try {
            const response = await fetch(`${this.apiUrl}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ pseudo, password: doubleHash }),
            });

            if (!response.ok) {
                throw new Error(`Login failed: ${response.statusText}`);
            }

            return await response.json(); // Return user data if login is successful
        } catch (error) {
            console.error('Error during login:', error);
            throw error;
        }
    }

    async register(user) {
        if (!user.pseudo || !user.password || !user.email) {
            throw new Error("Missing required user properties");
        }

        // Hash the password before sending it to the backend
        const hash = CryptoJS.SHA256(user.password).toString(CryptoJS.enc.Hex);
        const doubleHash = CryptoJS.SHA256(hash).toString(CryptoJS.enc.Hex);
        user.password = doubleHash;

        try {
            const response = await fetch(`${this.apiUrl}/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(user),
            });

            if (!response.ok) {
                throw new Error(`Registration failed: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error during registration:', error);
            throw error;
        }
    }

    async getUserById(id) {
        try {
            const response = await fetch(`${this.apiUrl}/users/${id}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch user: ${response.statusText}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Error fetching user by ID:', error);
            throw error;
        }
    }

    async updateUser(id, updatedUser) {
        if (!id) {
            throw new Error("Invalid ID provided for user update");
        }

        try {
            const response = await fetch(`${this.apiUrl}/users/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedUser),
            });

            if (!response.ok) {
                throw new Error(`Failed to update user: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error updating user:', error);
            throw error;
        }
    }

    async deleteUser(id) {
        try {
            const response = await fetch(`${this.apiUrl}/users/${id}`, {
                method: 'DELETE',
            });

            if (!response.ok) {
                throw new Error(`Failed to delete user: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error deleting user:', error);
            throw error;
        }
    }
}

export default UserRepository;
